import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Logger } from 'src/services/logger.service';

import { Regex } from 'lipp-components';

export const ConfirmRegistrationGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const router = inject(Router);

  const email: string | undefined = route.queryParams['e'];
  const token: string | undefined = route.queryParams['t'];

  if (!email || !token) {
    Logger.logError(
      `ERROR ConfirmRegistrationGuard: Cannot find needed query parameters.`
    );
    return router.createUrlTree(['/auth/login']);
  } else if (!Regex.email.test(email)) {
    Logger.logError(
      `ERROR ConfirmRegistrationGuard: Email from query parameters (${email}) is not a valid email.`
    );
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
